<template>
  <div>
    <div class="flex-center">
      <v-avatar
        v-for="(v, k) in teachers.slice(0, 2)"
        :key="`${uniKey}${k}`"
        v-model="v.avatar"
        :class="v.length > 1 ? `avatar-translate-${k}` : ''"
      >
      </v-avatar>
    </div>
    <span class="nickname">
      {{ teachers.map((teacher) => teacher.nickname).join(' / ') }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    uniKey: {
      type: String,
      default: 'avatarBrief',
    },
  },
  computed: {
    teachers() {
      return this.value.length === 0 ? [{ id: 0, nickname: '未知', avatar: '' }] : this.value;
    },
  },
};
</script>

<style scoped>
  .avatar-translate-0 {
    transform: translateX(20px);
  }

  .avatar-translate-1 {
    transform: translateX(-20px);
  }
</style>
